export default __webpack_public_path__ + "static/char-s-30-ja-27974b6475b8a5948358916a635f21a9.png";